import { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CartSidebar from './components/CartSidebar';
import ChatAssistant from './components/ChatAssistant';
import Toast from './components/Toast';
import Home from './pages';
import Products from './pages/Products';
import Deals from './pages/Deals';
import About from './pages/About';
import Contact from './pages/Contact';

export default function App() {
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  // Custom cursor
  useEffect(() => {
    const cursor = document.createElement('div');
    cursor.id = 'cursor';
    cursor.style.cssText = 'position:fixed;width:10px;height:10px;background:#00d4ff;border-radius:50%;pointer-events:none;z-index:99999;transform:translate(-50%,-50%);transition:width .2s,height .2s;mix-blend-mode:screen;';
    const ring = document.createElement('div');
    ring.id = 'cursor-ring';
    ring.style.cssText = 'position:fixed;width:32px;height:32px;border:1px solid rgba(0,212,255,.4);border-radius:50%;pointer-events:none;z-index:99998;transform:translate(-50%,-50%);transition:left .15s ease-out,top .15s ease-out,width .25s,height .25s;';
    document.body.appendChild(cursor);
    document.body.appendChild(ring);

    const onMove = (e) => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top  = e.clientY + 'px';
      ring.style.left   = e.clientX + 'px';
      ring.style.top    = e.clientY + 'px';
    };
    window.addEventListener('mousemove', onMove);
    return () => { window.removeEventListener('mousemove', onMove); cursor.remove(); ring.remove(); };
  }, []);

  return (
    <>
      <div className="grid-bg" />
      <Navbar onSearch={setSearchQuery} />
      <CartSidebar />
      <Toast />

      <Routes>
        <Route path="/"        element={<Home searchQuery={searchQuery} />} />
        <Route path="/products" element={<Products />} />
        <Route path="/deals"    element={<Deals />} />
        <Route path="/about"    element={<About />} />
        <Route path="/contact"  element={<Contact />} />
      </Routes>

      <Footer />
      <ChatAssistant />
    </>
  );
}
